import React from 'react'
import { Modal, Button, Grid } from 'semantic-ui-react'
import { iconCloseModalError } from '../../config'

class ActionModal extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			open: false
		}
	}

	render() {
		const { open, type, header, detail, typeAction, close, submit, cancelButtonName, isAxError } = this.props

		let _type = 'question'
			, _header = ''
			, _detail = ''
			, classModal = ''

		if (type) {
			_type = type
		}

		_header = header
		_detail = detail

		switch (_type) {
			case 'question':
				classModal = 'question'
				break;
			case 'warning':
				classModal = 'warning'
				break;
			case 'danger':
				classModal = `danger${isAxError ? ' axError' : ''}` //'danger'
				break;
			case 'detail':
				classModal = 'detail'
				break;
			case 'errorModal':
				classModal = 'errorModal'
				break;
			default:
				break;
		}

		return (
			<React.Fragment>
				<Modal open={open} onClose={close} size={classModal !== "detail" ? "tiny" : "large"}
					className="module actionModal">
					<Modal.Header className={`headerBG ${classModal}`}>
						<Grid>
							<Grid.Row>
								<Grid.Column width={16} className="inlineFlex">
									<div className={`boxHeaderContent`}>
										<div className="boxImageClose" onClick={this.props.close}>
											<img src={iconCloseModalError} alt="" />
										</div>
									</div>
								</Grid.Column>
							</Grid.Row>
						</Grid>
					</Modal.Header>
					<Modal.Content className={`bodyBg ${classModal}`}>
						<Modal.Description >
							<Grid>
								<Grid.Row columns={1}>
									<Grid.Column>
										<div className={`boxTextHeader ${classModal}`}>
											<p className={`dialogHeader ${classModal}`}>{_header}</p>
										</div>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row>
									<Grid.Column width={16}>
										<div className="boxTextDetail">
											<p>{_detail}</p>
											<div className="boxAction">

											</div>
										</div>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row>
									<Grid.Column textAlign="center">
										<Button className="btn btaBaseColor" onClick={close}>{cancelButtonName ? cancelButtonName : "Cancel"}</Button>
										{
											typeAction === 'delete' &&
											<Button className="btn delete" onClick={submit}>Delete</Button>
										}
									</Grid.Column>
								</Grid.Row>
							</Grid>



						</Modal.Description>
					</Modal.Content>
				</Modal>
			</React.Fragment>
		)
	}
}


export default ActionModal


// WEBPACK FOOTER //
// ./src/app/components/features/share/modal/actionModal.js